import React from 'react';
import {
    Box,
    Flex,
    IconButton,
    Stack,
    useDisclosure,
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Button,
    Link,
    Show,
    Hide,
    Image
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import LogoTea from "../../assets/tea-logoVersion.svg"

function LandingHeader() {
    const { isOpen, onOpen, onClose } = useDisclosure();

    // Navigation items
    const NavItem = ({ children, href }) => (
        <Link
            href={href}
            px={2}
            py={1}
            display="block"
            textAlign="center"
            fontSize="16px"
            fontWeight="500"
            fontFamily="Quicksand"
            lineHeight="25px"
            letterSpacing="0.08px"
            color="#313C45"
            _active={{
                color: "#0D1216",
                fontWeight: "700",
            }}
        // Esto da un total de 48px (24px cada lado) de separación entre elementos
        >
            {children}
        </Link>
    );

    const WaitlistButton = () => (
        <Button
            bg="#FCEBA2"
            color="#303030"
            fontFamily="Quicksand"
            fontSize="16px"
            fontWeight="700"
            lineHeight="25px"
            _hover={{ bg: "#f8e3a1" }} // Sutil cambio de color en hover
            _active={{
                bg: "#edd382",
            }}
            onClick={() => document.getElementById("Newletter").scrollIntoView({ behavior: "smooth" })}
        >
            Join Waitlist
        </Button>
    );

    return (
        <>
            <Box as="header" w="full" boxShadow="md" h="114px">
                <Flex
                    as="nav"
                    h="100%"
                    alignItems="center"
                    justifyContent="space-between"
                    px={{ base: 4, md: 100 }} // 100px para medium en adelante, 4 para base
                >
                    <Image
                        src={LogoTea}
                        alt="Logo de Tea"
                        maxHeight="60%"
                        objectFit="contain" // Esto asegura que el logo mantenga su proporción
                    />
                    <Show above="md">
                        <Stack direction={'row'} spacing={6} align="center">
                            <NavItem href="#">Home</NavItem>
                            <NavItem href="#Features">Features</NavItem>
                            <NavItem href="#Download">How does it work?</NavItem>
                            <NavItem href="#Partnerships">Partnerships</NavItem>
                            <NavItem href="#About">About</NavItem>
                            <WaitlistButton />
                        </Stack>
                    </Show>
                    <Hide above="md">
                        <IconButton
                            size="md"
                            icon={<HamburgerIcon />}
                            aria-label="Open Menu"
                            onClick={onOpen}
                        />
                    </Hide>
                </Flex>
            </Box>

            {/* Drawer for mobile view */}
            <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
                    <DrawerBody>
                        <Stack spacing={4}>
                            <NavItem href="#">Home</NavItem>
                            <NavItem href="#Features">Features</NavItem>
                            <NavItem href="#Download">How does it work?</NavItem>
                            <NavItem href="#Partnerships">Partnerships</NavItem>
                            <NavItem href="#About">About</NavItem>
                        </Stack>
                    </DrawerBody>
                    <DrawerFooter justifyContent="center">
                        <WaitlistButton />
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </>
    );
}

export default LandingHeader;
